import React, { useEffect, useState } from 'react'

const Title = (props) => {
    const id = props.id
    const reference = props.reference
    const type = props.type
    const title = props.title
    const show_latest_link = props.showLatest || false
    
    const full_title = ( reference || "<New "+type+">" ) + " " + title
    const [copied, setCopied] = useState(false)
    
    const copyToClipboard = (text) => {
        const textField = document.createElement('textarea')
        textField.innerText = text
        const parentElement = document.body
        parentElement.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        parentElement.removeChild(textField)
    }

    const onClick = (text) => {
        copyToClipboard(text)
        setCopied(true)
        setTimeout(() => {
            setCopied(false)
        }, 750)
    }
    
    if( ! reference ) {
        // It's a new item, don't offer onClick
        return (
            <h2>{type}: {full_title}</h2>
        )
    }

    const copyTitle = (
        <a className="grey" style={{marginLeft: "12px", fontSize: "14px"}} onClick={() => onClick(full_title)}
           data-tooltip-id="gnctooltip" data-tooltip-content="Copy full Reference and Title text to clipboard">
            <i className="fa fa-clone"></i>
        </a>
    )

    const copyLinkText = show_latest_link ? (
        'Copy permalink to clipboard. The permalink will always link to this version of the '+type+'.'
    ) : (
        'Copy permalink to clipboard'
    )
    
    const copyLink = id ? (
        <a className="grey" style={{marginLeft: "12px", fontSize: "14px"}} onClick={() => onClick(window.location.href)}
           data-tooltip-id="gnctooltip" data-tooltip-content={copyLinkText}>
            <i className="fa fa-link"></i>
        </a>
    ) : null
    
    const latestURL = window.location.href + '/latest'
    const latestLinkText = "Copy live-link to clipboard. The live-link will always link to the latest "+
                           ( type === 'Customer Document' ? 'Filed' : 'Live' ) +
                           " version of this " + type + ", or the Reserved version if no " +
                             ( type === 'Customer Document' ? 'Filed' : 'Live' ) +
                           " version exists."
    const latestLink = id && show_latest_link ? (
        <a className="grey" style={{marginLeft: "12px", fontSize: "14px"}} onClick={() => onClick(latestURL)}
           data-tooltip-id="gnctooltip" data-tooltip-content={latestLinkText}>
            <i className="fa fa-bolt"></i>
        </a>
    ) : null
    
    return (
        <h2>
            {type}: {full_title}
            {copyTitle}
            {copyLink}
            {latestLink}
            
            {copied &&
             <span style={{fontSize: '13px', marginLeft: '10px'}}>Copied!</span>
            }
        </h2>
    )
}
export default Title
